import { get, post } from "@/libs/http";
import { ActivityItem } from "@/features/activity/store/list";
import { ActivityCommonDetailReq, ActivityCommonDetailRes } from '@/types/api/hall/activity-common-detail';
import { createApiMutationHook } from '@/hooks/use-api-mutation';
import { createApiQuery } from '@/hooks/use-api-query';


// 查询活动列表
export const queryActivity = (utmAc?: string) => {
  return get<{ list: ActivityItem[]; }>('/activity/center/v1/list', { params: { utm_act: utmAc } }); // 真实接口路径和数据字段待后端提供
};

// 创建带 react-query 的活动列表查询 hook，配置 500ms 的 staleTime 来复用请求
export const useQueryActivity = createApiQuery(
  ({ utmAct }: { utmAct?: string; }) => queryActivity(utmAct),
  ({ utmAct }) => ['activity-list', utmAct]
);

// banner以及底部工具栏落地页详情
export const getBannerDetailApi = ({ params }: { params: ActivityCommonDetailReq; }) => {
  return post<ActivityCommonDetailRes>('/hall/v1/activity_common_detail', params);
};

export const useBannerDetailApi = createApiMutationHook(getBannerDetailApi);